export default __webpack_public_path__ + "static/media/_dkg_lunge_rgb.be0b673a.svg";